import { FC } from "react";
import { useTranslation } from "react-i18next";
import CustomPopup from "../../../custom-components/CustomPopup";
import { useNavigate } from "react-router-dom";

interface CompleteAccountPopupProps {
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}

const CompleteAccountPopup: FC<CompleteAccountPopupProps> = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const confirmHandler = () => {
        props.setIsVisible(false);
        navigate("/profile");
    };

    return (
        <CustomPopup
            isVisible={props.isVisible}
            setIsVisible={props.setIsVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px] border border-backgroundButton"
            confirmTitle={t("work.goToAccount")}
            confirmHandler={confirmHandler}
            confirmButtonClassName="h-[50px] dmax2:h-[40px] px-6 dmax2:px-4 mt-8 dmax2:mt-6"
        >
            <p className="H20B dmax2:H16 text-textWhite text-center mt-[10px] max-w-[460px] td4:max-w-[360px] tmax4:max-w-[292px]">
                {t("work.mustCompleteAccount")}
            </p>
        </CustomPopup>
    );
};

export default CompleteAccountPopup;
